<template>
    <div id="loading">

       <span class="logo"></span>

        <div class="loader">

            <radial-progress-bar :diameter="250" :animate-speed="80" :completed-steps="completedSteps"
                                 :total-steps="totalSteps" :start-color="startColor" :stop-color="stopColor">
                <p class="info-dl">
                    {{ txtSync }}
                </p>

                <div class="loader" id="loader-2" :class="{disabled: !loaderActif}">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div id="textInfo">
                    {{ textInfo }}
                </div>
            </radial-progress-bar>

        </div>

        <div class="actions-erreur" v-if="enErreur">
            <a class="btn btn-full" href="javascript: void 0" @click.prevent="reessayer">Réessayer</a>
            <a class="btn btn-wire" href="javascript: void 0" v-if="retourDisponible" @click.prevent="revenirApresEchec">Retour à l'installation</a>
            <a class="btn btn-wire" href="javascript: void 0" @click.prevent="allerAccueil">Accueil</a>
        </div>

    </div>
</template>

<script>

    import RadialProgressBar from 'vue-radial-progress'
    import Synchro from '../../js/core/Synchro'
    import Api from '../../js/core/Api'
    import localforage from 'localforage'
    import Security from '../../js/core/Security'
    import Installation from '../../js/models/Installation'

    const estTemporaire = id => String(id).indexOf('N-') === 0;

    export default {

        data() {
            return {
                txtSync: 'Synchonisation de vos données utilisateur',
                completedSteps: 0,
                totalSteps: 18,
                stopColor: "#fb950e",
                startColor: "#ffb100",
                textInfo: 'Merci de patienter',
                loaderActif: true,
                enErreur: false,
                retourDisponible: false,
                count: 0
            }
        },

        methods: {

            // MD-565 : appelee uniquement apres vidage effectif de la file
            // hors-ligne, seul moment ou l'on peut deconnecter un compte devenu
            // invalide (evaluation terminee, operateur desactive) sans perdre de
            // donnees. Une erreur reseau ne declenche rien : on redirige
            // normalement, l'utilisateur reessaiera.
            verifierAccesPuisRediriger() {
                const router = this.$router;
                const vue = this;

                Security.tryRefreshProfil(function(recovered, profil, refus) {
                    if (!recovered && refus) {
                        Synchro.effacerRetourApresSynchro();
                        Security.logoutRefus(function() {
                            // sweetalert2 6.x rejette la promesse sur esc/clic
                            // exterieur : sans handler de rejet l'utilisateur reste
                            // deconnecte sur un ecran figé.
                            const versLogin = function() { router.push({name: 'login'}); };
                            swal('Accès refusé', Security.libelleRefus(refus), 'error')
                                .then(versLogin, versLogin);
                        });

                        return;
                    }

                    vue.transmettreRetourAInit();
                    router.push({name: 'init'});
                });
            },

            afficherErreur() {
                this.textInfo = "Merci de relancer la synchro";
                this.loaderActif = false;
                this.enErreur = true;
                this.retourDisponible = !!Synchro.lireRetourApresSynchro();
            },

            // MD-793 : après une synchro réussie, InitLoading ouvre pendingRedirectAfterLogin une fois
            // les données rechargées. Un id resté N- (action purgée comme orpheline) ne mène plus à
            // rien : repli sur la liste des installations, ou l'accueil si le détenteur l'est aussi.
            transmettreRetourAInit() {
                const cible = Synchro.consommerRetourApresSynchro();
                if (!cible || estTemporaire(cible.idDet)) {
                    return;
                }

                const route = estTemporaire(cible.idInst)
                    ? {name: 'liste-installations', params: {id: cible.idDet}}
                    : {name: 'installation', params: {id: cible.idDet, idInst: cible.idInst}};

                try {
                    sessionStorage.setItem('pendingRedirectAfterLogin', this.$router.resolve(route).route.fullPath);
                } catch (e) {
                    // sessionStorage indisponible : retour à l'accueil, comme avant MD-793.
                }
            },

            // MD-793 : la synchro a échoué, on rouvre l'installation avec l'id qu'elle a à cet instant
            // (N-… si elle n'est pas partie : son action hors-ligne reste en file).
            async revenirApresEchec() {
                const cible = Synchro.consommerRetourApresSynchro();
                if (!cible) {
                    this.$router.push({name: 'home'});
                    return;
                }

                const installations = await Installation.getList();
                const existe = installations.some(i => String(i.id) === String(cible.idInst));

                this.$router.push(existe
                    ? {name: 'installation', params: {id: cible.idDet, idInst: cible.idInst}}
                    : {name: 'liste-installations', params: {id: cible.idDet}});
            },

            allerAccueil() {
                Synchro.effacerRetourApresSynchro();
                this.$router.push({name: 'home'});
            },

            reessayer() {
                this.enErreur = false;
                this.loaderActif = true;
                this.textInfo = 'Merci de patienter';
                this.txtSync = 'Synchonisation de vos données utilisateur';
                this.completedSteps = 0;
                this.launchSynchro();
            },

            async launchSynchro(){

                await localforage.setItem('syncInProgress', 'true');

                try {
                    await Synchro.syncUser();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des détenteurs";
                    await Synchro.syncDetenteurs();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des installations";
                    await Synchro.syncInstallations();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des informations installations";
                    await Synchro.syncInformationInstallations();
                    this.completedSteps++;


                    this.txtSync = "Synchronisation des bouteilles";
                    await Synchro.syncBouteilles();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des outils";
                    await Synchro.syncOutils();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des contrats d'assemblage";
                    await Synchro.syncContrats();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des fiches fibsdd";
                    await Synchro.syncFibsdds();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des operations bouteille";
                    await Synchro.syncOperationsBouteille();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des scans bouteille";
                    await Synchro.syncScansBouteille();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des autres scans";
                    await Synchro.syncScansInstallations();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des fuites";
                    await Synchro.syncFuites();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches pièces";
                    await Synchro.syncPieces();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches photos";
                    await Synchro.syncPhotos();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches fibsdd";
                    await Synchro.cloturesFinalesFibsdd();
                    this.completedSteps++;

                    this.txtSync = "Cloture des bouteilles";
                    await Synchro.cloturesFinalesBouteille();
                    this.completedSteps++;

                    this.txtSync = "Envoi des mails Fibsdd";
                    await Synchro.launchMailsFibsdd();
                    this.completedSteps++;

                    this.txtSync = "Envoi des mails restitution bouteille";
                    await Synchro.launchRestitsBouteille();
                    this.completedSteps++;
                    this.txtSync = "Synchronisation terminée";

                    this.loaderActif = false;

                    localforage
                        .setItem('offlineActions', JSON.stringify([]))
                        .then(() => localforage.removeItem('syncInProgress'))
                        .then(() => this.verifierAccesPuisRediriger())
                        .catch(() => {
                            // Le vidage de la file a echoue : l'invariant de
                            // verifierAccesPuisRediriger() n'est pas tenu, on ne
                            // controle donc pas l'acces ici.
                            localforage.removeItem('syncInProgress');
                            this.transmettreRetourAInit();
                            this.$router.push({name: 'init'});
                        })



                }
                catch (e) {
                    this.afficherErreur();
                    await localforage.removeItem('syncInProgress');

                    Api.init()
                        .then(api => api.post('/mail/report', {text: e instanceof Error ? e.message + '\n' + e.stack : JSON.stringify(e)}))
                        .catch(() => {});
                }

            }

        },

        mounted() {

            // Synchro lancée depuis le menu : un retour resté d'une synchro interrompue
            // (session expirée, onglet fermé) ne doit pas rediriger ailleurs.
            if (!this.$route.query.retour) {
                Synchro.effacerRetourApresSynchro();
            }

            this.launchSynchro()

        },

        // Page quittée en cours de synchro : la cible ne doit plus rediriger plus tard.
        beforeDestroy() {
            Synchro.effacerRetourApresSynchro();
        },

        components: {
            RadialProgressBar
        }

    }

</script>

<style scoped>
    img {
        display: block;
        margin: auto;
        width: 250px;
        margin-top: 50px;
        margin-bottom: 60px;
    }

    .radial-progress-container {
        margin: auto;
    }

    .actions-erreur {
        display: flex;
        max-width: 400px;
        margin: 20px auto 0;
    }

    .actions-erreur .btn {
        flex: 1;
        align-items: center;
        margin: 0 5px;
    }

    p.info-dl {
        text-align: center;
        width: 175px;
    }

    /* LOADER 2 */

    #loader-2 {
        margin-top: 15px;
    }

    #loader-2 span{
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 100%;
        background-color: #fb950e;
        margin: 25px 5px;
    }

    #loader-2 span:nth-child(1){
        animation: bounce 1s ease-in-out infinite;
    }

    #loader-2 span:nth-child(2){
        animation: bounce 1s ease-in-out 0.33s infinite;
    }

    #loader-2 span:nth-child(3){
        animation: bounce 1s ease-in-out 0.66s infinite;
    }

    #loader-2.disabled span:nth-child(3), #loader-2.disabled span:nth-child(2), #loader-2.disabled span:nth-child(1) {
        animation: none;
    }

    @keyframes bounce{
        0%, 75%, 100%{
            -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
            -o-transform: translateY(0);
            transform: translateY(0);
        }

        25%{
            -webkit-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
            transform: translateY(-20px);
        }
    }
</style>



// WEBPACK FOOTER //
// Synchro.vue?8e75e1ae